import { Box, Stack, Heading, Text, Button, Alert } from 'braid-design-system';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface UnauthorisedPageProps {
    message?: string;
}
const ForbiddenAccessPage = ({ message }: UnauthorisedPageProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <Box padding="large" display="flex" alignItems="center" justifyContent="center">
            <Stack space="large" align="center">
                <Heading level="1" align="center">
                    {t('page.forbidden.title', { defaultValue: '403 - Forbidden Access' })}
                </Heading>
                <Alert tone="caution">
                    <Text>
                        {t('page.forbidden.alert', { defaultValue: 'You are forbidden to access this page' })}
                        {message ? `, ${message}` : ''}
                    </Text>
                </Alert>
                <Text tone="secondary" align="center">
                    {t('page.forbidden.description', {
                        defaultValue:
                            'Sorry, you are forbidden to access this page.\nPlease contact the administrator if you believe this is an error.',
                    })}
                </Text>
                <Button variant="ghost" onClick={() => navigate('/')}>{t('page.forbidden.go_home', { defaultValue: 'Go to Home' })}</Button>
            </Stack>
        </Box>
    );
};

export default ForbiddenAccessPage;
